// Keeps a copy of the Firebase login in the phone's own app storage (iOS UserDefaults /
// Android SharedPreferences) so the user stays logged in even if the web view's
// localStorage / IndexedDB is wiped between launches. No-op in a normal browser,
// and harmless if the native plugin is missing (older app builds).
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const API_KEY = "AIzaSyDbjWZ491AH2ExDjslj_V-0RmmBFF7KVws";
const AUTH_KEY = `firebase:authUser:${API_KEY}:[DEFAULT]`;
const BACKUP_KEY = "gu_auth_backup_v1";

// Diagnostics are switched off (kept as no-ops so the calls elsewhere stay harmless).
export function diag() {}
export function diagSnapshot() {}

const isNative = () => { try { return Capacitor.isNativePlatform(); } catch { return false; } };
const withTimeout = (p, ms) => Promise.race([p, new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), ms))]);

// Runs BEFORE Firebase is loaded: if web storage lost the session, put it back.
export async function restoreNativeSession() {
  diag("build D1 native=" + isNative());
  if (!isNative()) return;
  try {
    const hadLocal = !!localStorage.getItem(AUTH_KEY);
    let hasBackup = false, restored = false;
    if (!hadLocal) {
      const { value } = await withTimeout(Preferences.get({ key: BACKUP_KEY }), 2000);
      hasBackup = !!value;
      if (value) { localStorage.setItem(AUTH_KEY, value); restored = true; }
    }
    diag("start ls=" + hadLocal + " backup=" + hasBackup + " restored=" + restored);
  } catch (e) { diag("restore-fail " + (e && (e.message || e.code))); }
}

export async function saveNativeSession() {
  if (!isNative()) return;
  try {
    const v = localStorage.getItem(AUTH_KEY);
    if (v) { await Preferences.set({ key: BACKUP_KEY, value: v }); diag("backup saved"); }
    else diag("backup skipped: no ls key");
  } catch (e) { diag("backup-fail " + (e && (e.message || e.code))); }
}

export async function clearNativeSession() {
  if (!isNative()) return;
  try { await Preferences.remove({ key: BACKUP_KEY }); } catch (e) { /* ignore */ }
}
